import { Component, OnInit } from '@angular/core';
import {Router, ActivatedRoute, Params} from '@angular/router';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import * as jsPDF from 'jspdf';
import * as html2canvas from 'html2canvas';
import * as moment from 'moment';

@Component({
  selector: 'app-company-stats',
  templateUrl: './company-stats.component.html'
})
export class CompanyStatsComponent implements OnInit {

  constructor(
  	private activatedRoute: ActivatedRoute, 
  	private http: HttpClient){ }

  gameId = 0;
  game: any = {};
  stats: any = {};
  isLoading: boolean = false;
  nbJours: number;

  showChartAges: boolean = false;
  public barChartAgesOptions:any = {
    scaleShowVerticalLines: false,
    responsive: true
  };
  public barChartAgesLabels:string[] = ['-18 ans', '18-25 ans', '25-35 ans', '35-45 ans', '45-55 ans', '55-65 ans', '+65 ans'];
  public barChartAgesType:string = 'bar';
  public barChartAgesLegend:boolean = true;
  public barChartAgesData:any[];
  public barChartAgesColors:any[] = [{ backgroundColor: '#81C8DF', borderColor: '#3EB8DD'}, { backgroundColor: '#C99AA8', borderColor: '#C6758D'}];

  showChartPlayersDates: boolean = false;
  public lineChartPlayersDatesData:any[];
  public lineChartPlayersDatesLabels:any[];
  public lineChartPlayersDatesOptions:any = {responsive: true};
  public lineChartPlayersDatesColors:any[] = [
    { 
      backgroundColor: 'rgba(0,0,0,0)',
      borderColor: '#EAB14A',
      pointBackgroundColor: '#EAB14A',
      pointBorderColor: '#EAB14A',
      pointHoverBackgroundColor: '#EAB14A',
      pointHoverBorderColor: '#EAB14A'
    },
    { 
      backgroundColor: '#4466AE',
      borderColor: '#4466AE',
      pointBackgroundColor: '#4466AE',
      pointBorderColor: '#4466AE',
      pointHoverBackgroundColor: '#4466AE',
      pointHoverBorderColor: '#4466AE'
    }
  ];
  public lineChartPlayersDatesLegend:boolean = true;
  public lineChartPlayersDatesType:string = 'line';

  showChartByDpt: boolean = false;
  public pieChartDptLabels:string[];
  public pieChartDptData:number[];
  public pieChartDptType:string = 'pie';

  ngOnInit() {


  	// get route param
    this.activatedRoute.params.subscribe((params: Params) => {
        this.gameId = params['id'];
      });

    // GetGameStats
    this.http.get(environment.symfonyEndpointSecuredForCompany + environment.apiGetStatsByGame + this.gameId).map((res: Response) => res).subscribe(results => {
      this.game = results['game']; 
      this.nbJours = moment(this.game.endDate).diff(moment(this.game.startDate), 'days');
      this.stats = results['stats'];
      this.loadBarChartAges();
      this.loadLineChartPlaysersDate();
      this.loadPieChartByDpt();

      console.log(results);
    })
  }

  	loadBarChartAges(){
	  	this.barChartAgesData = [
		    {data: [
		    	this.stats['boyMoins18'],
		    	this.stats['boy1825'],
		    	this.stats['boy2535'],
		    	this.stats['boy3545'],
		    	this.stats['boy4555'],
		    	this.stats['boy5565'],
		    	this.stats['boyPlus65']], 
		    label: 'Hommes',
			backgroundColor: 'blue'},
			{data: [
		    	this.stats['girlMoins18'],
		    	this.stats['girl1825'],
		    	this.stats['girl2535'],
		    	this.stats['girl3545'],
		    	this.stats['girl4555'],
		    	this.stats['girl5565'],
		    	this.stats['girlPlus65']], 
		    label: 'Femmes'}
		    
		  ];
		this.showChartAges = true;
  	}

  	loadLineChartPlaysersDate(){
  		let labels: string[] = [];
  		let datas: string[] = [];
  		let datasCumulees: string[] = [];
  		let previousData = 0;
		this.stats['playersByDate'].forEach(element => {
		    labels.push(element.firstPlay);
		    datas.push(element.nbPlayers);
		    datasCumulees.push(String(Number(previousData) + Number(element.nbPlayers)));
		    previousData = element.nbPlayers;
		});

		this.lineChartPlayersDatesLabels = labels;
 		this.lineChartPlayersDatesData = [
 			{data: datas, label: 'Nombre de nouveaux joueurs par jour'},
 			{data: datasCumulees, label: 'Nombre de joueurs cumulés'}
 		];
  		this.showChartPlayersDates = true;
  	}

  	loadPieChartByDpt(){
  		let labels: string[] = [];
  		let datas: number[] = [];
  		this.stats['playersByDpt'].forEach(element => {
		    labels.push(element.dpt);
		    datas.push(Number(element.nbPlayersByDpt));
		});

		this.pieChartDptLabels = labels;
 		this.pieChartDptData = datas;
  		this.showChartByDpt = true;
  	}

  	downloadPDF() {
  		// A4 paper in mm = 210 x 297

  		this.isLoading = true;
  		let self = this; // https://stackoverflow.com/questions/20279484/how-to-access-the-correct-this-inside-a-callback
  		let pdf = new jsPDF();
  		let nameFile = "Uclics-stats-" + this.game['name'] + "-" + moment().format('DD-MM-YYYY'); + ".pdf";
		html2canvas(document.getElementById('pdf_content_page1')).then(function(canvas) {
		    let imgGraph1 = canvas.toDataURL('image/png');
		    pdf.addImage(imgGraph1, 'PNG', 0, 0, 210, (canvas.height/(canvas.width/210)));

		    pdf.addPage();
		    html2canvas(document.getElementById('pdf_content_page2')).then(function(canvas) {
			    let imgGraph2 = canvas.toDataURL('image/png');
			    if(canvas.width > canvas.height){
					pdf.addImage(imgGraph2, 'PNG', 0, 0, 210, (canvas.height/(canvas.width/210)));
				}
			    
			    pdf.addPage();
			    html2canvas(document.getElementById('pdf_content_page3')).then(function(canvas) {
				    let imgGraph3 = canvas.toDataURL('image/png');
				    pdf.addImage(imgGraph3, 'PNG', 0, 0, 210, (canvas.height/(canvas.width/210)));

				    self.isLoading = false;
					pdf.save(nameFile);
				});
			});
		});
		
	}


}



// WEBPACK FOOTER //
// C:/wamp64/www/Uclics/demo/angular/src/app/components/company/company-stats/company-stats.component.ts